"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _default = function _default(theme) {
  return {
    root: (0, _extends2.default)({}, theme.typography.defaultText, {
      lineHeight: '20px',
      color: theme.colors.text.greySoft,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center'
    }),
    Text: {
      paddingRight: 5
    },
    info: {
      display: 'block',
      width: 10
    },
    icon: {
      display: 'block',
      width: 10,
      height: 10,
      cursor: 'pointer',
      '& path': {
        fill: theme.colors.disabledGrey
      }
    }
  };
};

exports.default = _default;